import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OffersService } from '../../../../shared/services/admServices/offers.service';
import { sortModeClass } from '../../../../models/admModel/offer.model';
import { Options, LabelType } from 'ngx-slider-v2';

@Component({
  selector: 'admin-offer-settings',
  templateUrl: './settings.html',
  styleUrls: ['./settings.scss'],
})

export class settingsOfferComponent implements OnInit {

  mode1color: string;
  mode2color: string;
  mode3color: string;
  mode4color: string;
  checkMode1: boolean;
  checkMode2: any;
  checkMode3: any;
  checkMode4: any;
  sortMode = new sortModeClass();
  modeData: any;
  epcInDays: any;

  constructor(private offersService: OffersService, private toastrService: ToastrService) {}

  ngOnInit() {
    this.getMode();
  };

  // Custom class slider
  SliderOptionsEPC: Options = {
    floor: 1,
    ceil: 30,
    step: 1,
    //showTicks: false,
    readOnly: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>days:</b> ' + value;
        default:
          return `${value}`;
      }
    }
  };

  getMode(){
    //uruchomienie API
    this.offersService.getMode()
    .subscribe(
     data => {
      this.modeData = data.data.id;
      this.epcInDays = data.data.epcInDays;

      if(this.modeData == 1)
      {
        this.checkMode1=true;
        this.mode1color = "bg-success";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: false});

        this.checkMode2=false;
        this.mode2color = "";
        this.checkMode3=false;
        this.mode3color = "";
      }
      if(this.modeData == 2)
      {
        this.checkMode2=true;
        this.mode2color = "bg-success";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: true});

        this.checkMode1 = false;
        this.mode1color = "";
        this.checkMode3=false;
        this.mode3color = "";
      }
      if(this.modeData == 3)
      {
        this.checkMode3=true;
        this.mode3color = "bg-success";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: true});

        this.checkMode1 = false;
        this.mode1color = "";
        this.checkMode2=false;
        this.mode2color = "";
      }
     },
     error => {
       console.log(error);
     });
  }

  setMode(mode: any){
    this.sortMode.id = mode;
    this.sortMode.EpcInDays = this.epcInDays;

    // uruchomienie API
    this.offersService.setMode(this.sortMode)
    .subscribe(
     data => {
      if(mode == 1)
        this.toastrService.success('Changed sorting mode to 1 with short term ECP(' + this.sortMode.EpcInDays + ')', 'Success !');
      else
        this.toastrService.success('Changed sorting mode to ' + this.sortMode.id, 'Success !');
     },
     error => {
        this.toastrService.error('Changed sorting mode.', 'Error !');
       console.log(error);
     });
  }

  onChange(item){
    if(item.target.value == 1)
      {
        this.modeData = 1;
        this.mode1color = "bg-success";

        this.mode2color = "";
        this.mode3color = "";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: false});

        this.setMode(1);
      }
    if(item.target.value == 2)
      {
        this.modeData = 2;
        this.mode2color = "bg-success";

        this.mode1color = "";
        this.mode3color = "";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: true});

        this.setMode(2);
      }
    if(item.target.value == 3)
      {
        this.modeData = 3;
        this.mode3color = "bg-success";

        this.mode1color = "";
        this.mode2color = "";
        this.SliderOptionsEPC = Object.assign({}, this.SliderOptionsEPC, {readOnly: true});

        this.setMode(3);
      }
  };

  onChangeSlider(){
    if(this.modeData == 1 )
      this.setMode(1);
  }
}
